<template>
  <div v-if="cashInMethod">
    <cash-in-method-details
      :data-cash-in-method.sync="cashInMethod"
      @update:dataCashInMethod="updateCashInMethod"
    />
    <transaction-fees
      class="mt-3"
      hasSendingCountry
      hasReceivingCountry
      :fees_url="`/api/v1/transactions/transferCashInMethod/${cashInMethod.id}/fees`"
    />
  </div>
</template>

<script>
import TransactionFees from "../fees";
import CashInMethodDetails from "./details";

export default {
  props: {
    id: {
      required: true,
    },
  },
  components: {
    TransactionFees,
    CashInMethodDetails,
  },
  data: () => ({
    cashInMethod: null,
  }),
  mounted() {
    this.fetchCashInMethod();
  },
  watch: {
    id() {
      this.fetchCashInMethod();
    },
  },
  methods: {
    fetchCashInMethod() {
      this.$http
        .get(`/api/v1/transactions/transferCashInMethods/${this.id}`)
        .then((cashInMethod) => (this.cashInMethod = cashInMethod));
    },
    updateCashInMethod(cashInMethod) {
      if (cashInMethod) {
        this.cashInMethod = cashInMethod;
      }
    },
  },
};
</script>

<style></style>
